import React from 'react';

import { CardBase } from './styles';

export const Box: React.FC = ({ children }) => {
  return <CardBase>{children}</CardBase>;
};
